import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ReactNode } from "react";

interface ModalProps { 
    open: boolean
    onClose? : () => void
    modalTitle?: ReactNode, 
    imageUri?: string,
    closeButton?: ReactNode 
    children?: ReactNode
}

export default function Modal(props: ModalProps) {
    const { open, onClose, modalTitle, imageUri, children, closeButton } = props;

    return (
        <div onClick={onClose} className={
            `fixed inset-0 flex justify-center items-center transition-colors w-full z-[999] ${open ? "visible bg-black/20" : "invisible" }`  
        }>
            <div 
                onClick={(e) => e.stopPropagation()}
                className={
                    `relative bg-white rounded-xl shadow transition-all w-fit h-fit duration-500
                    ${open ? "translate-y-0 opacity-100" : "-translate-y-1/2 opacity-0"}
                    `
            }>
                {onClose && <button 
                    onClick={onClose}
                    className="absolute top-8 right-8 border-none bg-transparent">
                    { closeButton == undefined 
                        ? <FontAwesomeIcon icon={faTimesCircle} size={"2x"}></FontAwesomeIcon>
                        : closeButton 
                    }
                </button>}
                <div className="flex flex-col justify-center items-center px-6 py-2 mt-6">
                    {imageUri && <img src={imageUri} alt="" className="w-24 uto mb-2" />}
                    { typeof(modalTitle) === "string" 
                        ? <h5 className="block font-extrabold text-xl text-black text-center max-w-sm">
                            {modalTitle}
                        </h5>
                        : modalTitle
                    }
                    {children}
                </div>
            </div>
        </div>
    );
}
